export const nearbyCitiesSample = [
	{
		city: "Herndon",
		state: "VA",
		uri: "self-storage/virginia/herndon/",
		content_id: 3234,
		num_facilities: 198,
		distance: 4
	},
	{
		city: "Sterling",
		state: "VA",
		uri: "self-storage/virginia/sterling/",
		content_id: 3254,
		num_facilities: 183,
		distance: 4
	},
	{
		city: "Vienna",
		state: "VA",
		uri: "self-storage/virginia/vienna/",
		content_id: 245979,
		num_facilities: 216,
		distance: 4
	},
	{
		city: "Ashburn",
		state: "VA",
		uri: "self-storage/virginia/ashburn/",
		content_id: 244355,
		num_facilities: 163,
		distance: 4
	},
	{
		city: "Chantilly",
		state: "VA",
		uri: "self-storage/virginia/chantilly/",
		content_id: 3220,
		num_facilities: 183,
		distance: 4
	},
	{
		city: "Potomac",
		state: "MD",
		uri: "self-storage/maryland/potomac/",
		content_id: 263043,
		num_facilities: 228,
		distance: 4
	},
	{
		city: "Fairfax",
		state: "VA",
		uri: "self-storage/virginia/fairfax/",
		content_id: 3229,
		num_facilities: 214,
		distance: 4
	},
	{
		city: "Merrifield",
		state: "VA",
		uri: "self-storage/virginia/merrifield/",
		content_id: 249693,
		num_facilities: 217,
		distance: 4
	},
	{
		city: "McLean",
		state: "VA",
		uri: "self-storage/virginia/mclean/",
		content_id: 3241,
		num_facilities: 228,
		distance: 4
	},
	{
		city: "Lansdowne",
		state: "VA",
		uri: "self-storage/virginia/lansdowne/",
		content_id: 250979,
		num_facilities: 150,
		distance: 4
	}
];

export const stateWiseCities = [
	{
		state: "Alabama",
		abbreviation: "AL",
		cities: [
			{
				name: "Huntsville",
				uri: "self-storage/alabama/huntsville/",
				latitude: 34.729847,
				longitude: -86.5859011
			},
			{
				name: "Mobile",
				uri: "self-storage/alabama/mobile/",
				latitude: 30.6913462,
				longitude: -88.0437509
			},
			{
				name: "Tuscaloosa",
				uri: "self-storage/alabama/tuscaloosa/",
				latitude: 33.2095614,
				longitude: -87.5675258
			},
			{
				name: "Montgomery",
				uri: "self-storage/alabama/montgomery/",
				latitude: 32.3777111,
				longitude: -86.3090775
			},
			{
				name: "Birmingham",
				uri: "self-storage/alabama/birmingham/",
				latitude: 33.5206824,
				longitude: -86.8024326
			},
			{
				name: "Madison",
				uri: "self-storage/alabama/madison/",
				latitude: 34.6734784,
				longitude: -86.7519434
			},
			{
				name: "Auburn",
				uri: "self-storage/alabama/auburn/",
				latitude: 32.6098566,
				longitude: -85.4807825
			},
			{
				name: "Dothan",
				uri: "self-storage/alabama/dothan/",
				latitude: 31.2237285,
				longitude: -85.3934375
			},
			{
				name: "Florence",
				uri: "self-storage/alabama/florence/",
				latitude: 34.79981,
				longitude: -87.677251
			},
			{
				name: "Opelika",
				uri: "self-storage/alabama/opelika/",
				latitude: 32.6471024,
				longitude: -85.3807278
			}
		]
	},
	{
		state: "Alaska",
		abbreviation: "AK",
		cities: [
			{
				name: "Anchorage",
				uri: "self-storage/alaska/anchorage/",
				latitude: 61.2163129,
				longitude: -149.894852
			},
			{
				name: "Fairbanks",
				uri: "self-storage/alaska/fairbanks/",
				latitude: 64.837845,
				longitude: -147.716675
			},
			{
				name: "Wasilla",
				uri: "self-storage/alaska/wasilla/",
				latitude: 61.5824216,
				longitude: -149.442563
			},
			{
				name: "Juneau",
				uri: "self-storage/alaska/juneau/",
				latitude: 58.3019613,
				longitude: -134.4196751
			},
			{
				name: "Palmer",
				uri: "self-storage/alaska/palmer/",
				latitude: 61.5995703,
				longitude: -149.11109
			},
			{
				name: "Homer",
				uri: "self-storage/alaska/homer/",
				latitude: 59.6426471,
				longitude: -151.5495995
			},
			{
				name: "Kenai",
				uri: "self-storage/alaska/kenai/",
				latitude: 60.560082,
				longitude: -151.2070094
			},
			{
				name: "Sterling",
				uri: "self-storage/alaska/sterling/",
				latitude: 60.5122222,
				longitude: -150.8958333
			},
			{
				name: "Ketchikan",
				uri: "self-storage/alaska/ketchikan/",
				latitude: 55.3430696,
				longitude: -131.6466819
			},
			{
				name: "Badger",
				uri: "self-storage/alaska/badger/",
				latitude: 64.7858333,
				longitude: -148.0680556
			}
		]
	},
	{
		state: "Arizona",
		abbreviation: "AZ",
		cities: [
			{
				name: "Mesa",
				uri: "self-storage/arizona/mesa/",
				latitude: 33.4151005,
				longitude: -111.831455
			},
			{
				name: "Tucson",
				uri: "self-storage/arizona/tucson/",
				latitude: 32.2228765,
				longitude: -110.974847
			},
			{
				name: "Phoenix",
				uri: "self-storage/arizona/phoenix/",
				latitude: 33.4484367,
				longitude: -112.074141
			},
			{
				name: "Scottsdale",
				uri: "self-storage/arizona/scottsdale/",
				latitude: 33.4942189,
				longitude: -111.926018
			},
			{
				name: "Gilbert",
				uri: "self-storage/arizona/gilbert/",
				latitude: 33.3527632,
				longitude: -111.789037
			},
			{
				name: "Glendale",
				uri: "self-storage/arizona/glendale/",
				latitude: 33.5386858,
				longitude: -112.185994
			},
			{
				name: "Chandler",
				uri: "self-storage/arizona/chandler/",
				latitude: 33.3062031,
				longitude: -111.841185
			},
			{
				name: "Surprise",
				uri: "self-storage/arizona/surprise/",
				latitude: 33.6386015,
				longitude: -112.3687041
			},
			{
				name: "Yuma",
				uri: "self-storage/arizona/yuma/",
				latitude: 32.7254216,
				longitude: -114.6198088
			},
			{
				name: "Flagstaff",
				uri: "self-storage/arizona/flagstaff/",
				latitude: 35.1945999,
				longitude: -111.7612424
			}
		]
	},
	{
		state: "Arkansas",
		abbreviation: "AR",
		cities: [
			{
				name: "Bentonville",
				uri: "self-storage/arkansas/bentonville/",
				latitude: 36.3728608,
				longitude: -94.208787
			},
			{
				name: "Conway",
				uri: "self-storage/arkansas/conway/",
				latitude: 35.0891932,
				longitude: -92.4398402
			},
			{
				name: "Jonesboro",
				uri: "self-storage/arkansas/jonesboro/",
				latitude: 35.8348088,
				longitude: -90.7045297
			},
			{
				name: "Little Rock",
				uri: "self-storage/arkansas/little-rock/",
				latitude: 34.7465071,
				longitude: -92.2896267
			},
			{
				name: "Springdale",
				uri: "self-storage/arkansas/springdale/",
				latitude: 36.1867442,
				longitude: -94.1288142
			},
			{
				name: "Fayetteville",
				uri: "self-storage/arkansas/fayetteville/",
				latitude: 36.0625843,
				longitude: -94.1574328
			},
			{
				name: "Fort Smith",
				uri: "self-storage/arkansas/fort-smith/",
				latitude: 35.3880338,
				longitude: -94.4265011
			},
			{
				name: "Rogers",
				uri: "self-storage/arkansas/rogers/",
				latitude: 36.334857,
				longitude: -94.1193816
			},
			{
				name: "Benton",
				uri: "self-storage/arkansas/benton/",
				latitude: 34.5659819,
				longitude: -92.5881081
			},
			{
				name: "Hot Springs",
				uri: "self-storage/arkansas/hot-springs/",
				latitude: 34.5038393,
				longitude: -93.0552437
			}
		]
	},
	{
		state: "California",
		abbreviation: "CA",
		cities: [
			{
				name: "San Jose",
				uri: "self-storage/california/san-jose/",
				latitude: 37.3361663,
				longitude: -121.890591
			},
			{
				name: "Long Beach",
				uri: "self-storage/california/long-beach/",
				latitude: 33.7690164,
				longitude: -118.191604
			},
			{
				name: "Bakersfield",
				uri: "self-storage/california/bakersfield/",
				latitude: 35.3733093,
				longitude: -119.0187125
			},
			{
				name: "Modesto",
				uri: "self-storage/california/modesto/",
				latitude: 37.6391127,
				longitude: -120.9968782
			},
			{
				name: "San Francisco",
				uri: "self-storage/california/san-francisco/",
				latitude: 37.7879363,
				longitude: -122.4075201
			},
			{
				name: "San Diego",
				uri: "self-storage/california/san-diego/",
				latitude: 32.7174202,
				longitude: -117.162772
			},
			{
				name: "Stockton",
				uri: "self-storage/california/stockton/",
				latitude: 37.9577016,
				longitude: -121.2907797
			},
			{
				name: "Fresno",
				uri: "self-storage/california/fresno/",
				latitude: 36.7394421,
				longitude: -119.78483
			},
			{
				name: "Sacramento",
				uri: "self-storage/california/sacramento/",
				latitude: 38.5810606,
				longitude: -121.493895
			},
			{
				name: "Los Angeles",
				uri: "self-storage/california/los-angeles/",
				latitude: 34.0536909,
				longitude: -118.242766
			}
		]
	},
	{
		state: "Colorado",
		abbreviation: "CO",
		cities: [
			{
				name: "Denver",
				uri: "self-storage/colorado/denver/",
				latitude: 39.7392364,
				longitude: -104.984862
			},
			{
				name: "Longmont",
				uri: "self-storage/colorado/longmont/",
				latitude: 40.1672117,
				longitude: -105.101928
			},
			{
				name: "Fort Collins",
				uri: "self-storage/colorado/fort-collins/",
				latitude: 40.5871782,
				longitude: -105.0770113
			},
			{
				name: "Aurora",
				uri: "self-storage/colorado/aurora/",
				latitude: 39.7405111,
				longitude: -104.830994
			},
			{
				name: "Boulder",
				uri: "self-storage/colorado/boulder/",
				latitude: 40.0149856,
				longitude: -105.270545
			},
			{
				name: "Lakewood",
				uri: "self-storage/colorado/lakewood/",
				latitude: 39.7085736,
				longitude: -105.0846694
			},
			{
				name: "Loveland",
				uri: "self-storage/colorado/loveland/",
				latitude: 40.3977612,
				longitude: -105.07498
			},
			{
				name: "Colorado Springs",
				uri: "self-storage/colorado/colorado-springs/",
				latitude: 38.8339578,
				longitude: -104.825348
			},
			{
				name: "Pueblo",
				uri: "self-storage/colorado/pueblo/",
				latitude: 38.2544412,
				longitude: -104.6091014
			},
			{
				name: "Greeley",
				uri: "self-storage/colorado/greeley/",
				latitude: 40.4233142,
				longitude: -104.7091322
			}
		]
	},
	{
		state: "Connecticut",
		abbreviation: "CT",
		cities: [
			{
				name: "Norwalk",
				uri: "self-storage/connecticut/norwalk/",
				latitude: 41.1175966,
				longitude: -73.4078968
			},
			{
				name: "Stamford",
				uri: "self-storage/connecticut/stamford/",
				latitude: 41.0534302,
				longitude: -73.5387341
			},
			{
				name: "New Haven",
				uri: "self-storage/connecticut/new-haven/",
				latitude: 41.3082138,
				longitude: -72.9250518
			},
			{
				name: "Manchester",
				uri: "self-storage/connecticut/manchester/",
				latitude: 41.7839168,
				longitude: -72.5154435
			},
			{
				name: "Waterbury",
				uri: "self-storage/connecticut/waterbury/",
				latitude: 41.5538091,
				longitude: -73.0438362
			},
			{
				name: "Danbury",
				uri: "self-storage/connecticut/danbury/",
				latitude: 41.394817,
				longitude: -73.4540111
			},
			{
				name: "Meriden",
				uri: "self-storage/connecticut/meriden/",
				latitude: 41.5373149,
				longitude: -72.8063128
			},
			{
				name: "Hamden",
				uri: "self-storage/connecticut/hamden/",
				latitude: 41.3913825,
				longitude: -72.7642839
			},
			{
				name: "Middletown",
				uri: "self-storage/connecticut/middletown/",
				latitude: 41.5629806,
				longitude: -72.6553177
			},
			{
				name: "Bridgeport",
				uri: "self-storage/connecticut/bridgeport/",
				latitude: 41.1792695,
				longitude: -73.1887863
			}
		]
	},
	{
		state: "Delaware",
		abbreviation: "DE",
		cities: [
			{
				name: "Wilmington",
				uri: "self-storage/delaware/wilmington/",
				latitude: 39.7459468,
				longitude: -75.546589
			},
			{
				name: "Newark",
				uri: "self-storage/delaware/newark/",
				latitude: 39.6828358,
				longitude: -75.7515682
			},
			{
				name: "Dover",
				uri: "self-storage/delaware/dover/",
				latitude: 39.158168,
				longitude: -75.5243682
			},
			{
				name: "Middletown",
				uri: "self-storage/delaware/middletown/",
				latitude: 39.4497639,
				longitude: -75.7166345
			},
			{
				name: "Millsboro",
				uri: "self-storage/delaware/millsboro/",
				latitude: 38.5915023,
				longitude: -75.2913018
			},
			{
				name: "Smyrna",
				uri: "self-storage/delaware/smyrna/",
				latitude: 39.2866816,
				longitude: -75.5987289
			},
			{
				name: "Milford",
				uri: "self-storage/delaware/milford/",
				latitude: 38.9130453,
				longitude: -75.4278733
			},
			{
				name: "Bear",
				uri: "self-storage/delaware/bear/",
				latitude: 39.6331108,
				longitude: -75.6431485
			},
			{
				name: "Claymont",
				uri: "self-storage/delaware/claymont/",
				latitude: 39.7950451,
				longitude: -75.4532361
			},
			{
				name: "Seaford",
				uri: "self-storage/delaware/seaford/",
				latitude: 38.6413452,
				longitude: -75.6114584
			}
		]
	},
	{
		state: "Florida",
		abbreviation: "FL",
		cities: [
			{
				name: "Miami",
				uri: "self-storage/florida/miami/",
				latitude: 25.7741566,
				longitude: -80.1935973
			},
			{
				name: "Gainesville",
				uri: "self-storage/florida/gainesville/",
				latitude: 29.6519684,
				longitude: -82.3249846
			},
			{
				name: "Jacksonville",
				uri: "self-storage/florida/jacksonville/",
				latitude: 30.3262247,
				longitude: -81.6579179
			},
			{
				name: "Tampa",
				uri: "self-storage/florida/tampa/",
				latitude: 27.9449854,
				longitude: -82.4583107
			},
			{
				name: "St Petersburg",
				uri: "self-storage/florida/st-petersburg/",
				latitude: 27.7712264,
				longitude: -82.6340259
			},
			{
				name: "Tallahassee",
				uri: "self-storage/florida/tallahassee/",
				latitude: 30.4380832,
				longitude: -84.2809332
			},
			{
				name: "Orlando",
				uri: "self-storage/florida/orlando/",
				latitude: 28.5421218,
				longitude: -81.379045
			},
			{
				name: "Lakeland",
				uri: "self-storage/florida/lakeland/",
				latitude: 28.0394821,
				longitude: -81.9498311
			},
			{
				name: "Cape Coral",
				uri: "self-storage/florida/cape-coral/",
				latitude: 26.5628468,
				longitude: -81.9495251
			},
			{
				name: "West Palm Beach",
				uri: "self-storage/florida/west-palm-beach/",
				latitude: 26.7153282,
				longitude: -80.0534294
			}
		]
	},
	{
		state: "Georgia",
		abbreviation: "GA",
		cities: [
			{
				name: "Atlanta",
				uri: "self-storage/georgia/atlanta/",
				latitude: 33.7544657,
				longitude: -84.3898151
			},
			{
				name: "Athens",
				uri: "self-storage/georgia/athens/",
				latitude: 33.9597677,
				longitude: -83.376398
			},
			{
				name: "Columbus",
				uri: "self-storage/georgia/columbus/",
				latitude: 32.4610708,
				longitude: -84.9880449
			},
			{
				name: "Marietta",
				uri: "self-storage/georgia/marietta/",
				latitude: 33.9528472,
				longitude: -84.5496148
			},
			{
				name: "Savannah",
				uri: "self-storage/georgia/savannah/",
				latitude: 32.0790074,
				longitude: -81.0921335
			},
			{
				name: "Macon",
				uri: "self-storage/georgia/macon/",
				latitude: 32.8406946,
				longitude: -83.6324022
			},
			{
				name: "Augusta",
				uri: "self-storage/georgia/augusta/",
				latitude: 33.4709714,
				longitude: -81.9748429
			},
			{
				name: "Valdosta",
				uri: "self-storage/georgia/valdosta/",
				latitude: 30.8326087,
				longitude: -83.2792316
			},
			{
				name: "Warner Robins",
				uri: "self-storage/georgia/warner-robins/",
				latitude: 32.7785904,
				longitude: -83.6187381
			},
			{
				name: "Smyrna",
				uri: "self-storage/georgia/smyrna/",
				latitude: 33.8804705,
				longitude: -84.5199455
			}
		]
	},
	{
		state: "Hawaii",
		abbreviation: "HI",
		cities: [
			{
				name: "Honolulu",
				uri: "self-storage/hawaii/honolulu/",
				latitude: 21.304547,
				longitude: -157.855676
			},
			{
				name: "Kahului",
				uri: "self-storage/hawaii/kahului/",
				latitude: 20.8894101,
				longitude: -156.4727118
			},
			{
				name: "Kihei",
				uri: "self-storage/hawaii/kihei/",
				latitude: 20.7581393,
				longitude: -156.4730923
			},
			{
				name: "Kailua",
				uri: "self-storage/hawaii/kailua/",
				latitude: 21.3686592,
				longitude: -157.7380031
			},
			{
				name: "Kapolei",
				uri: "self-storage/hawaii/kapolei/",
				latitude: 21.3340079,
				longitude: -158.077849
			},
			{
				name: "Waipahu",
				uri: "self-storage/hawaii/waipahu/",
				latitude: 21.3866667,
				longitude: -158.009166
			},
			{
				name: "Hilo",
				uri: "self-storage/hawaii/hilo/",
				latitude: 19.7073734,
				longitude: -155.08158
			},
			{
				name: "Kaneohe",
				uri: "self-storage/hawaii/kaneohe/",
				latitude: 21.418555,
				longitude: -157.804184
			},
			{
				name: "Kailua Kona",
				uri: "self-storage/hawaii/kailua-kona/",
				latitude: 19.6400556,
				longitude: -155.9964835
			},
			{
				name: "Pearl City",
				uri: "self-storage/hawaii/pearl-city/",
				latitude: 21.4001231,
				longitude: -157.969428
			}
		]
	},
	{
		state: "Idaho",
		abbreviation: "ID",
		cities: [
			{
				name: "Idaho Falls",
				uri: "self-storage/idaho/idaho-falls/",
				latitude: 43.4887907,
				longitude: -112.03628
			},
			{
				name: "Moscow",
				uri: "self-storage/idaho/moscow/",
				latitude: 46.7313585,
				longitude: -117.2877825
			},
			{
				name: "Chubbuck",
				uri: "self-storage/idaho/chubbuck/",
				latitude: 42.8676483,
				longitude: -112.4108055
			},
			{
				name: "Meridian",
				uri: "self-storage/idaho/meridian/",
				latitude: 43.6086295,
				longitude: -116.392326
			},
			{
				name: "Boise",
				uri: "self-storage/idaho/boise/",
				latitude: 43.6166163,
				longitude: -116.200886
			},
			{
				name: "Post Falls",
				uri: "self-storage/idaho/post-falls/",
				latitude: 47.7110106,
				longitude: -116.9480877
			},
			{
				name: "Hayden",
				uri: "self-storage/idaho/hayden/",
				latitude: 47.7621265,
				longitude: -116.7910883
			},
			{
				name: "Lewiston",
				uri: "self-storage/idaho/lewiston/",
				latitude: 46.4125488,
				longitude: -117.0171089
			},
			{
				name: "Nampa",
				uri: "self-storage/idaho/nampa/",
				latitude: 43.5737361,
				longitude: -116.559631
			},
			{
				name: "Kuna",
				uri: "self-storage/idaho/kuna/",
				latitude: 43.4865236,
				longitude: -116.4184969
			}
		]
	},
	{
		state: "Illinois",
		abbreviation: "IL",
		cities: [
			{
				name: "Chicago",
				uri: "self-storage/illinois/chicago/",
				latitude: 41.8755616,
				longitude: -87.6244212
			},
			{
				name: "Champaign",
				uri: "self-storage/illinois/champaign/",
				latitude: 40.1164841,
				longitude: -88.2430932
			},
			{
				name: "Peoria",
				uri: "self-storage/illinois/peoria/",
				latitude: 40.6938609,
				longitude: -89.5891008
			},
			{
				name: "Rockford",
				uri: "self-storage/illinois/rockford/",
				latitude: 42.2713945,
				longitude: -89.093966
			},
			{
				name: "Springfield",
				uri: "self-storage/illinois/springfield/",
				latitude: 39.7990175,
				longitude: -89.6439575
			},
			{
				name: "Bloomington",
				uri: "self-storage/illinois/bloomington/",
				latitude: 40.4797828,
				longitude: -88.9939147
			},
			{
				name: "Joliet",
				uri: "self-storage/illinois/joliet/",
				latitude: 41.5261333,
				longitude: -88.0812325
			},
			{
				name: "Decatur",
				uri: "self-storage/illinois/decatur/",
				latitude: 39.8404948,
				longitude: -88.9440573
			},
			{
				name: "Naperville",
				uri: "self-storage/illinois/naperville/",
				latitude: 41.7728699,
				longitude: -88.1479278
			},
			{
				name: "Aurora",
				uri: "self-storage/illinois/aurora/",
				latitude: 41.7607793,
				longitude: -88.3201233
			}
		]
	},
	{
		state: "Indiana",
		abbreviation: "IN",
		cities: [
			{
				name: "Bloomington",
				uri: "self-storage/indiana/bloomington/",
				latitude: 39.1670396,
				longitude: -86.5342881
			},
			{
				name: "Greenwood",
				uri: "self-storage/indiana/greenwood/",
				latitude: 39.6119656,
				longitude: -86.1107688
			},
			{
				name: "Terre Haute",
				uri: "self-storage/indiana/terre-haute/",
				latitude: 39.4667025,
				longitude: -87.4139119
			},
			{
				name: "Evansville",
				uri: "self-storage/indiana/evansville/",
				latitude: 37.970495,
				longitude: -87.5715641
			},
			{
				name: "Anderson",
				uri: "self-storage/indiana/anderson/",
				latitude: 40.106193,
				longitude: -85.6902619
			},
			{
				name: "Fishers",
				uri: "self-storage/indiana/fishers/",
				latitude: 39.9451389,
				longitude: -86.0186768
			},
			{
				name: "Indianapolis",
				uri: "self-storage/indiana/indianapolis/",
				latitude: 39.7683331,
				longitude: -86.1583502
			},
			{
				name: "South Bend",
				uri: "self-storage/indiana/south-bend/",
				latitude: 41.6833813,
				longitude: -86.2500066
			},
			{
				name: "Elkhart",
				uri: "self-storage/indiana/elkhart/",
				latitude: 41.6819935,
				longitude: -85.9766671
			},
			{
				name: "Kokomo",
				uri: "self-storage/indiana/kokomo/",
				latitude: 40.4866906,
				longitude: -86.1349605
			}
		]
	},
	{
		state: "Iowa",
		abbreviation: "IA",
		cities: [
			{
				name: "Cedar Rapids",
				uri: "self-storage/iowa/cedar-rapids/",
				latitude: 41.9758872,
				longitude: -91.6704053
			},
			{
				name: "Iowa City",
				uri: "self-storage/iowa/iowa-city/",
				latitude: 41.6612561,
				longitude: -91.5299106
			},
			{
				name: "Marion",
				uri: "self-storage/iowa/marion/",
				latitude: 42.1693627,
				longitude: -91.5931108
			},
			{
				name: "Sioux City",
				uri: "self-storage/iowa/sioux-city/",
				latitude: 42.4966815,
				longitude: -96.4058782
			},
			{
				name: "Des Moines",
				uri: "self-storage/iowa/des-moines/",
				latitude: 41.5868654,
				longitude: -93.6249494
			},
			{
				name: "Council Bluffs",
				uri: "self-storage/iowa/council-bluffs/",
				latitude: 41.258841,
				longitude: -95.8519484
			},
			{
				name: "Dubuque",
				uri: "self-storage/iowa/dubuque/",
				latitude: 42.5006243,
				longitude: -90.6647985
			},
			{
				name: "Ankeny",
				uri: "self-storage/iowa/akeny/",
				latitude: 41.7398769,
				longitude: -93.5844635
			},
			{
				name: "Davenport",
				uri: "self-storage/iowa/davenport/",
				latitude: 41.5235808,
				longitude: -90.5770967
			},
			{
				name: "Mason City",
				uri: "self-storage/iowa/mason-city/",
				latitude: 43.1607705,
				longitude: -93.2050389
			}
		]
	},
	{
		state: "Kansas",
		abbreviation: "KS",
		cities: [
			{
				name: "Wichita",
				uri: "self-storage/kansas/wichita/",
				latitude: 37.6922361,
				longitude: -97.3375448
			},
			{
				name: "Manhattan",
				uri: "self-storage/kansas/manhattan/",
				latitude: 39.1836082,
				longitude: -96.5716694
			},
			{
				name: "Lawrence",
				uri: "self-storage/kansas/lawrence/",
				latitude: 38.9719137,
				longitude: -95.2359403
			},
			{
				name: "Topeka",
				uri: "self-storage/kansas/topeka/",
				latitude: 39.049011,
				longitude: -95.677556
			},
			{
				name: "Overland Park",
				uri: "self-storage/kansas/overland-park/",
				latitude: 38.9742502,
				longitude: -94.6851702
			},
			{
				name: "Hutchinson",
				uri: "self-storage/kansas/hutchinson/",
				latitude: 38.0606342,
				longitude: -97.8854632
			},
			{
				name: "Olathe",
				uri: "self-storage/kansas/olathe/",
				latitude: 38.8838856,
				longitude: -94.81887
			},
			{
				name: "Salina",
				uri: "self-storage/kansas/salina/",
				latitude: 38.8402805,
				longitude: -97.6114237
			},
			{
				name: "Junction City",
				uri: "self-storage/kansas/junction-city/",
				latitude: 39.0286093,
				longitude: -96.8313978
			},
			{
				name: "Gardner",
				uri: "self-storage/kansas/gardner/",
				latitude: 38.8069978,
				longitude: -94.9371518
			}
		]
	},
	{
		state: "Kentucky",
		abbreviation: "KY",
		cities: [
			{
				name: "Louisville",
				uri: "self-storage/kentucky/louisville/",
				latitude: 38.2542376,
				longitude: -85.759407
			},
			{
				name: "Lexington",
				uri: "self-storage/kentucky/lexington/",
				latitude: 38.0464066,
				longitude: -84.4970393
			},
			{
				name: "Bowling Green",
				uri: "self-storage/kentucky/bowling-green/",
				latitude: 36.9929203,
				longitude: -86.4428677
			},
			{
				name: "Owensboro",
				uri: "self-storage/kentucky/owensboro/",
				latitude: 37.7742152,
				longitude: -87.1133304
			},
			{
				name: "Richmond",
				uri: "self-storage/kentucky/richmond/",
				latitude: 37.7478572,
				longitude: -84.2946539
			},
			{
				name: "Frankfort",
				uri: "self-storage/kentucky/frankfort/",
				latitude: 38.2009621,
				longitude: -84.8733633
			},
			{
				name: "Georgetown",
				uri: "self-storage/kentucky/georgetown/",
				latitude: 38.2009621,
				longitude: -84.2281148
			},
			{
				name: "Elizabethtown",
				uri: "self-storage/kentucky/elizabethtown/",
				latitude: 37.6936667,
				longitude: -85.8627778
			},
			{
				name: "Florence",
				uri: "self-storage/kentucky/florence/",
				latitude: 38.9989499,
				longitude: -84.6266111
			},
			{
				name: "Paducah",
				uri: "self-storage/kentucky/paducah/",
				latitude: 37.0833893,
				longitude: -88.6000478
			}
		]
	},
	{
		state: "Louisiana",
		abbreviation: "LA",
		cities: [
			{
				name: "Lafayette",
				uri: "self-storage/louisiana/lafayette/",
				latitude: 30.2262187,
				longitude: -92.0178202
			},
			{
				name: "Baton Rouge",
				uri: "self-storage/louisiana/baton-rouge/",
				latitude: 30.4494155,
				longitude: -91.1869659
			},
			{
				name: "Shreveport",
				uri: "self-storage/louisiana/shreveport/",
				latitude: 32.5135356,
				longitude: -93.7477839
			},
			{
				name: "Metairie",
				uri: "self-storage/louisiana/metairie/",
				latitude: 29.9899926,
				longitude: -90.1505426
			},
			{
				name: "Hammond",
				uri: "self-storage/louisiana/hammond/",
				latitude: 30.5049832,
				longitude: -90.4639053
			},
			{
				name: "Slidell",
				uri: "self-storage/louisiana/slidell/",
				latitude: 30.2751945,
				longitude: -89.7811745
			},
			{
				name: "Monroe",
				uri: "self-storage/louisiana/monroe/",
				latitude: 32.5025471,
				longitude: -92.116219
			},
			{
				name: "New Orleans",
				uri: "self-storage/louisiana/new-orleans/",
				latitude: 29.9561422,
				longitude: -90.0733934
			},
			{
				name: "Lake Charles",
				uri: "self-storage/louisiana/lake-charles/",
				latitude: 30.2305095,
				longitude: -93.2169807
			},
			{
				name: "Houma",
				uri: "self-storage/louisiana/houma/",
				latitude: 29.5958349,
				longitude: -90.7126834
			}
		]
	},
	{
		state: "Maine",
		abbreviation: "ME",
		cities: [
			{
				name: "Bangor",
				uri: "self-storage/maine/bangor/",
				latitude: 44.8016255,
				longitude: -68.7713289
			},
			{
				name: "Windham",
				uri: "self-storage/maine/windham/",
				latitude: 43.8124306,
				longitude: -70.4099969
			},
			{
				name: "Portland",
				uri: "self-storage/maine/portland/",
				latitude: 43.6573605,
				longitude: -70.2586618
			},
			{
				name: "Scarborough",
				uri: "self-storage/maine/scarborough/",
				latitude: 43.590148,
				longitude: -70.3344722
			},
			{
				name: "Auburn",
				uri: "self-storage/maine/auburn/",
				latitude: 44.0965374,
				longitude: -70.2249487
			},
			{
				name: "Gorham",
				uri: "self-storage/maine/gorham/",
				latitude: 43.6786629,
				longitude: -70.4612932
			},
			{
				name: "Kennebunk",
				uri: "self-storage/maine/kennebunk/",
				latitude: 43.7439803,
				longitude: -70.4703667
			},
			{
				name: "Saco",
				uri: "self-storage/maine/saco/",
				latitude: 43.4988461,
				longitude: -70.4612275
			},
			{
				name: "Sanford",
				uri: "self-storage/maine/sanford/",
				latitude: 43.4447222,
				longitude: -70.7652778
			},
			{
				name: "Wells",
				uri: "self-storage/maine/wells/",
				latitude: 43.3352778,
				longitude: -70.5741667
			}
		]
	},
	{
		state: "Maryland",
		abbreviation: "MD",
		cities: [
			{
				name: "Rockville",
				uri: "self-storage/maryland/rockville/",
				latitude: 39.0817985,
				longitude: -77.1516844
			},
			{
				name: "Waldorf",
				uri: "self-storage/maryland/waldorf/",
				latitude: 38.6329896,
				longitude: -76.8816405
			},
			{
				name: "Frederick",
				uri: "self-storage/maryland/frederick/",
				latitude: 39.415779,
				longitude: -77.4127562
			},
			{
				name: "Gaithersburg",
				uri: "self-storage/maryland/gaithersburg/",
				latitude: 39.1399187,
				longitude: -77.1929215
			},
			{
				name: "Baltimore",
				uri: "self-storage/maryland/baltimore/",
				latitude: 39.2908816,
				longitude: -76.610759
			},
			{
				name: "Bel Air",
				uri: "self-storage/maryland/bel-air/",
				latitude: 39.5537222,
				longitude: -76.3394444
			},
			{
				name: "Columbia",
				uri: "self-storage/maryland/columbia/",
				latitude: 39.2029375,
				longitude: -76.8861661
			},
			{
				name: "Germantown",
				uri: "self-storage/maryland/germantown/",
				latitude: 39.181334,
				longitude: -77.266647
			},
			{
				name: "Silver Spring",
				uri: "self-storage/maryland/silver-spring/",
				latitude: 38.9959461,
				longitude: -77.0276231
			},
			{
				name: "Bethesda",
				uri: "self-storage/maryland/bethesda/",
				latitude: 38.9846816,
				longitude: -77.0942447
			}
		]
	},
	{
		state: "Massachusetts",
		abbreviation: "MA",
		cities: [
			{
				name: "Quincy",
				uri: "self-storage/massachusetts/quincy/",
				latitude: 42.2509914,
				longitude: -71.0037374
			},
			{
				name: "Boston",
				uri: "self-storage/massachusetts/boston/",
				latitude: 42.3588336,
				longitude: -71.0578303
			},
			{
				name: "Lowell",
				uri: "self-storage/massachusetts/lowell/",
				latitude: 42.6356422,
				longitude: -71.3162164
			},
			{
				name: "Springfield",
				uri: "self-storage/massachusetts/springfield/",
				latitude: 42.1018764,
				longitude: -72.5886727
			},
			{
				name: "Worcester",
				uri: "self-storage/massachusetts/worcester/",
				latitude: 42.2625621,
				longitude: -71.8018877
			},
			{
				name: "Plymouth",
				uri: "self-storage/massachusetts/plymouth/",
				latitude: 41.9584127,
				longitude: -70.3640137
			},
			{
				name: "Fall River",
				uri: "self-storage/massachusetts/fall-river/",
				latitude: 41.7037475,
				longitude: -71.1550361
			},
			{
				name: "Lynn",
				uri: "self-storage/massachusetts/lynn/",
				latitude: 42.4659625,
				longitude: -70.9605102
			},
			{
				name: "Brockton",
				uri: "self-storage/massachusetts/brockton/",
				latitude: 42.0834426,
				longitude: -71.0142469
			},
			{
				name: "Taunton",
				uri: "self-storage/massachusetts/taunton/",
				latitude: 41.8995584,
				longitude: -71.0872848
			}
		]
	},
	{
		state: "Michigan",
		abbreviation: "MI",
		cities: [
			{
				name: "Lansing",
				uri: "self-storage/michigan/lansing/",
				latitude: 42.7338254,
				longitude: -84.5546295
			},
			{
				name: "Kalamazoo",
				uri: "self-storage/michigan/kalamazoo/",
				latitude: 42.291707,
				longitude: -85.5872286
			},
			{
				name: "Grand Rapids",
				uri: "self-storage/michigan/grand-rapids/",
				latitude: 42.9632425,
				longitude: -85.6678639
			},
			{
				name: "Ann Arbor",
				uri: "self-storage/michigan/ann-arbor/",
				latitude: 42.2813722,
				longitude: -83.7484616
			},
			{
				name: "Canton",
				uri: "self-storage/michigan/canton/",
				latitude: 42.3086486,
				longitude: -83.4821605
			},
			{
				name: "Detroit",
				uri: "self-storage/michigan/detroit/",
				latitude: 42.3315509,
				longitude: -83.0466403
			},
			{
				name: "Flint",
				uri: "self-storage/michigan/flint/",
				latitude: 43.0161693,
				longitude: -83.6900211
			},
			{
				name: "Warren",
				uri: "self-storage/michigan/warren/",
				latitude: 42.5144566,
				longitude: -83.0146526
			},
			{
				name: "Southfield",
				uri: "self-storage/michigan/southfield/",
				latitude: 42.4733688,
				longitude: -83.2218731
			},
			{
				name: "Sterling Heights",
				uri: "self-storage/michigan/sterling-heights/",
				latitude: 42.5803122,
				longitude: -83.0302033
			}
		]
	},
	{
		state: "Minnesota",
		abbreviation: "MN",
		cities: [
			{
				name: "Duluth",
				uri: "self-storage/minnesota/duluth/",
				latitude: 46.7838287,
				longitude: -92.1052679
			},
			{
				name: "Minneapolis",
				uri: "self-storage/minnesota/minneapolis/",
				latitude: 44.9772995,
				longitude: -93.2654692
			},
			{
				name: "Rochester",
				uri: "self-storage/minnesota/rochester/",
				latitude: 44.0234387,
				longitude: -92.4630182
			},
			{
				name: "St Paul",
				uri: "self-storage/minnesota/st-paul/",
				latitude: 44.9497487,
				longitude: -93.0931028
			},
			{
				name: "Bloomington",
				uri: "self-storage/minnesota/bloomington/",
				latitude: 44.840798,
				longitude: -93.298279
			},
			{
				name: "St Cloud",
				uri: "self-storage/minnesota/st-cloud/",
				latitude: 45.574643,
				longitude: -94.1205808
			},
			{
				name: "Shakopee",
				uri: "self-storage/minnesota/shakopee/",
				latitude: 44.7980186,
				longitude: -93.5268986
			},
			{
				name: "Woodbury",
				uri: "self-storage/minnesota/woodbury/",
				latitude: 44.923855,
				longitude: -92.959379
			},
			{
				name: "Blaine",
				uri: "self-storage/minnesota/blaine/",
				latitude: 45.160799,
				longitude: -93.234948
			},
			{
				name: "Maple Grove",
				uri: "self-storage/minnesota/maple-grove/",
				latitude: 45.072464,
				longitude: -93.455787
			}
		]
	},
	{
		state: "Mississippi",
		abbreviation: "MS",
		cities: [
			{
				name: "Oxford",
				uri: "self-storage/mississippi/oxford/",
				latitude: 34.3663773,
				longitude: -89.5187664
			},
			{
				name: "Gulfport",
				uri: "self-storage/mississippi/gulfport/",
				latitude: 30.3674198,
				longitude: -89.0928155
			},
			{
				name: "Jackson",
				uri: "self-storage/mississippi/jackson/",
				latitude: 32.2998686,
				longitude: -90.1830408
			},
			{
				name: "Hattiesburg",
				uri: "self-storage/mississippi/hattiesburg/",
				latitude: 31.3271189,
				longitude: -89.2903392
			},
			{
				name: "Starkville",
				uri: "self-storage/mississippi/starkville/",
				latitude: 33.4638745,
				longitude: -88.8152074
			},
			{
				name: "Olive Branch",
				uri: "self-storage/mississippi/olive-branch/",
				latitude: 34.96176,
				longitude: -89.829531
			},
			{
				name: "Biloxi",
				uri: "self-storage/mississippi/biloxi/",
				latitude: 30.4007626,
				longitude: -88.8893818
			},
			{
				name: "Southaven",
				uri: "self-storage/mississippi/southaven/",
				latitude: 34.9873822,
				longitude: -90.0034862
			},
			{
				name: "Tupelo",
				uri: "self-storage/mississippi/tupelo/",
				latitude: 34.2576067,
				longitude: -88.7033859
			},
			{
				name: "Meridian",
				uri: "self-storage/mississippi/meridian/",
				latitude: 32.36431,
				longitude: -88.703656
			}
		]
	},
	{
		state: "Missouri",
		abbreviation: "MO",
		cities: [
			{
				name: "Springfield",
				uri: "self-storage/missouri/springfield/",
				latitude: 37.2081729,
				longitude: -93.2922715
			},
			{
				name: "Kansas City",
				uri: "self-storage/missouri/kansas-city/",
				latitude: 39.100105,
				longitude: -94.5781416
			},
			{
				name: "Columbia",
				uri: "self-storage/missouri/columbia/",
				latitude: 38.951883,
				longitude: -92.3337366
			},
			{
				name: "St Louis",
				uri: "self-storage/missouri/st-louis/",
				latitude: 38.6254063,
				longitude: -90.190009
			},
			{
				name: "Joplin",
				uri: "self-storage/missouri/joplin/",
				latitude: 37.0841838,
				longitude: -94.5133385
			},
			{
				name: "Cape Girardeau",
				uri: "self-storage/missouri/cape-girardeau/",
				latitude: 37.305884,
				longitude: -89.518147
			},
			{
				name: "Independence",
				uri: "self-storage/missouri/independence/",
				latitude: 39.0924792,
				longitude: -94.4137923
			},
			{
				name: "Jefferson City",
				uri: "self-storage/missouri/jefferson-city/",
				latitude: 38.577359,
				longitude: -92.1724265
			},
			{
				name: "St Charles",
				uri: "self-storage/missouri/st-charles/",
				latitude: 38.788107,
				longitude: -90.497435
			},
			{
				name: "Lees Summit",
				uri: "self-storage/missouri/lees-summit/",
				latitude: 38.9108408,
				longitude: -94.3821724
			}
		]
	},
	{
		state: "Montana",
		abbreviation: "MT",
		cities: [
			{
				name: "Billings",
				uri: "self-storage/montana/billings/",
				latitude: 45.7874957,
				longitude: -108.49607
			},
			{
				name: "Missoula",
				uri: "self-storage/montana/missoula/",
				latitude: 46.8701049,
				longitude: -113.995267
			},
			{
				name: "Bozeman",
				uri: "self-storage/montana/bozeman/",
				latitude: 45.6794293,
				longitude: -111.044047
			},
			{
				name: "Helena",
				uri: "self-storage/montana/helena/",
				latitude: 46.5927425,
				longitude: -112.036277
			},
			{
				name: "Kalispell",
				uri: "self-storage/montana/kalispell/",
				latitude: 48.202158,
				longitude: -114.315321
			},
			{
				name: "Butte",
				uri: "self-storage/montana/butte/",
				latitude: 46.0131505,
				longitude: -112.536508
			},
			{
				name: "Belgrade",
				uri: "self-storage/montana/belgrade/",
				latitude: 45.773279,
				longitude: -111.184535
			},
			{
				name: "Livingston",
				uri: "self-storage/montana/livingston/",
				latitude: 45.662909,
				longitude: -110.560234
			},
			{
				name: "Havre",
				uri: "self-storage/montana/havre/",
				latitude: 48.550013,
				longitude: -109.684601
			},
			{
				name: "Laurel",
				uri: "self-storage/montana/laurel/",
				latitude: 45.669927,
				longitude: -108.771867
			}
		]
	},
	{
		state: "Nebraska",
		abbreviation: "NE",
		cities: [
			{
				name: "Lincoln",
				uri: "self-storage/nebraska/lincoln/",
				latitude: 40.8088861,
				longitude: -96.7077751
			},
			{
				name: "Omaha",
				uri: "self-storage/nebraska/omaha/",
				latitude: 41.2587459,
				longitude: -95.9383758
			},
			{
				name: "Kearney",
				uri: "self-storage/nebraska/kearney/",
				latitude: 40.69945,
				longitude: -99.081477
			},
			{
				name: "North Platte",
				uri: "self-storage/nebraska/north-platte/",
				latitude: 41.140276,
				longitude: -100.760145
			},
			{
				name: "Grand Island",
				uri: "self-storage/nebraska/grand-island/",
				latitude: 40.924271,
				longitude: -98.338685
			},
			{
				name: "Hastings",
				uri: "self-storage/nebraska/hastings/",
				latitude: 40.5861322,
				longitude: -98.3898883
			},
			{
				name: "Norfolk",
				uri: "self-storage/nebraska/norfolk/",
				latitude: 42.0283379,
				longitude: -97.4169964
			},
			{
				name: "Bellevue",
				uri: "self-storage/nebraska/bellevue/",
				latitude: 41.1365122,
				longitude: -95.8937398
			},
			{
				name: "Fremont",
				uri: "self-storage/nebraska/fremont/",
				latitude: 41.4338363,
				longitude: -96.4960449
			},
			{
				name: "York",
				uri: "self-storage/nebraska/york/",
				latitude: 40.867392,
				longitude: -97.592012
			}
		]
	},
	{
		state: "Nevada",
		abbreviation: "NV",
		cities: [
			{
				name: "Las Vegas",
				uri: "self-storage/nevada/las-vegas/",
				latitude: 36.1674263,
				longitude: -115.1484131
			},
			{
				name: "Henderson",
				uri: "self-storage/nevada/henderson/",
				latitude: 36.0319602,
				longitude: -114.9822716
			},
			{
				name: "Reno",
				uri: "self-storage/nevada/reno/",
				latitude: 39.529633,
				longitude: -119.813803
			},
			{
				name: "North Las Vegas",
				uri: "self-storage/nevada/north-las-vegas/",
				latitude: 36.2005191,
				longitude: -115.1214745
			},
			{
				name: "Carson City",
				uri: "self-storage/nevada/carson-city/",
				latitude: 39.1663259,
				longitude: -119.7670374
			},
			{
				name: "Sparks",
				uri: "self-storage/nevada/sparks/",
				latitude: 39.5404679,
				longitude: -119.7487235
			},
			{
				name: "Elko",
				uri: "self-storage/nevada/elko/",
				latitude: 40.83269,
				longitude: -115.7630942
			},
			{
				name: "Fernley",
				uri: "self-storage/nevada/fernley/",
				latitude: 39.6076575,
				longitude: -119.2509808
			},
			{
				name: "Pahrump",
				uri: "self-storage/nevada/pahrump/",
				latitude: 36.1925194,
				longitude: -115.9758446
			},
			{
				name: "Mesquite",
				uri: "self-storage/nevada/mesquite/",
				latitude: 36.805531,
				longitude: -114.066227
			}
		]
	},
	{
		state: "New Hampshire",
		abbreviation: "NH",
		cities: [
			{
				name: "Manchester",
				uri: "self-storage/new-hampshire/manchester/",
				latitude: 42.9956397,
				longitude: -71.4547891
			},
			{
				name: "Nashua",
				uri: "self-storage/new-hampshire/nashua/",
				latitude: 42.7656251,
				longitude: -71.4677032
			},
			{
				name: "Concord",
				uri: "self-storage/new-hampshire/concord/",
				latitude: 43.207178,
				longitude: -71.537476
			},
			{
				name: "Salem",
				uri: "self-storage/new-hampshire/salem/",
				latitude: 42.7884957,
				longitude: -71.2009035
			},
			{
				name: "Dover",
				uri: "self-storage/new-hampshire/dover/",
				latitude: 43.1981117,
				longitude: -70.8739761
			},
			{
				name: "Keene",
				uri: "self-storage/new-hampshire/keene/",
				latitude: 42.933692,
				longitude: -72.27814
			},
			{
				name: "Derry",
				uri: "self-storage/new-hampshire/derry/",
				latitude: 42.880642,
				longitude: -71.327112
			},
			{
				name: "Merrimack",
				uri: "self-storage/new-hampshire/merrimack/",
				latitude: 42.865086,
				longitude: -71.4934
			},
			{
				name: "Portsmouth",
				uri: "self-storage/new-hampshire/portsmouth/",
				latitude: 43.071755,
				longitude: -70.762554
			},
			{
				name: "Hudson",
				uri: "self-storage/new-hampshire/hudson/",
				latitude: 42.765366,
				longitude: -71.467566
			}
		]
	},
	{
		state: "New Jersey",
		abbreviation: "NJ",
		cities: [
			{
				name: "Jersey City",
				uri: "self-storage/new-jersey/jersey-city/",
				latitude: 40.7215682,
				longitude: -74.047455
			},
			{
				name: "Newark",
				uri: "self-storage/new-jersey/newark/",
				latitude: 40.735657,
				longitude: -74.1723667
			},
			{
				name: "Brick",
				uri: "self-storage/new-jersey/brick/",
				latitude: 40.058324,
				longitude: -74.137081
			},
			{
				name: "Clifton",
				uri: "self-storage/new-jersey/clifton/",
				latitude: 40.858433,
				longitude: -74.163755
			},
			{
				name: "Elizabeth",
				uri: "self-storage/new-jersey/elizabeth/",
				latitude: 40.6639916,
				longitude: -74.2107006
			},
			{
				name: "Toms River",
				uri: "self-storage/new-jersey/toms-river/",
				latitude: 39.953736,
				longitude: -74.197945
			},
			{
				name: "Edison",
				uri: "self-storage/new-jersey/edison/",
				latitude: 40.518157,
				longitude: -74.4113926
			},
			{
				name: "Paterson",
				uri: "self-storage/new-jersey/paterson/",
				latitude: 40.9167654,
				longitude: -74.171811
			},
			{
				name: "Bayonne",
				uri: "self-storage/new-jersey/bayonne/",
				latitude: 40.668714,
				longitude: -74.114309
			},
			{
				name: "Cherry Hill",
				uri: "self-storage/new-jersey/cherry-hill/",
				latitude: 39.926814,
				longitude: -75.024631
			}
		]
	},
	{
		state: "New Mexico",
		abbreviation: "NM",
		cities: [
			{
				name: "Santa Fe",
				uri: "self-storage/new-mexico/santa-fe/",
				latitude: 35.6876096,
				longitude: -105.938456
			},
			{
				name: "Albuquerque",
				uri: "self-storage/new-mexico/albuquerque/",
				latitude: 35.0841034,
				longitude: -106.650985
			},
			{
				name: "Farmington",
				uri: "self-storage/new-mexico/farmington/",
				latitude: 36.7280583,
				longitude: -108.2186856
			},
			{
				name: "Las Cruces",
				uri: "self-storage/new-mexico/las-cruces/",
				latitude: 32.3140354,
				longitude: -106.779807
			},
			{
				name: "Roswell",
				uri: "self-storage/new-mexico/roswell/",
				latitude: 33.3942655,
				longitude: -104.5230242
			},
			{
				name: "Alamogordo",
				uri: "self-storage/new-mexico/alamogordo/",
				latitude: 32.8998822,
				longitude: -105.9602081
			},
			{
				name: "Clovis",
				uri: "self-storage/new-mexico/clovis/",
				latitude: 34.405472,
				longitude: -103.2050709
			},
			{
				name: "Hobbs",
				uri: "self-storage/new-mexico/hobbs/",
				latitude: 32.7026116,
				longitude: -103.1360403
			},
			{
				name: "Rio Rancho",
				uri: "self-storage/new-mexico/rio-rancho/",
				latitude: 35.3108227,
				longitude: -106.6847453
			},
			{
				name: "Carlsbad",
				uri: "self-storage/new-mexico/carlsbad/",
				latitude: 32.4257456,
				longitude: -104.237612
			}
		]
	},
	{
		state: "New York",
		abbreviation: "NY",
		cities: [
			{
				name: "Rochester",
				uri: "self-storage/new-york/rochester/",
				latitude: 43.157285,
				longitude: -77.615214
			},
			{
				name: "Buffalo",
				uri: "self-storage/new-york/buffalo/",
				latitude: 42.8864163,
				longitude: -78.8781493
			},
			{
				name: "Syracuse",
				uri: "self-storage/new-york/syracuse/",
				latitude: 43.0481221,
				longitude: -76.1474244
			},
			{
				name: "Albany",
				uri: "self-storage/new-york/albany/",
				latitude: 42.6514458,
				longitude: -73.7555513
			},
			{
				name: "Yonkers",
				uri: "self-storage/new-york/yonkers/",
				latitude: 40.9312099,
				longitude: -73.8987469
			},
			{
				name: "New York",
				uri: "self-storage/new-york/new-york/",
				latitude: 40.7127281,
				longitude: -74.0060152
			},
			{
				name: "Cheektowaga",
				uri: "self-storage/new-york/cheektowaga/",
				latitude: 42.903334,
				longitude: -78.754765
			},
			{
				name: "Greece",
				uri: "self-storage/new-york/greece/",
				latitude: 43.209783,
				longitude: -77.693058
			},
			{
				name: "Hempstead",
				uri: "self-storage/new-york/hempstead/",
				latitude: 40.7062128,
				longitude: -73.6187397
			},
			{
				name: "Amherst",
				uri: "self-storage/new-york/amherst/",
				latitude: 42.9783882,
				longitude: -78.7996549
			}
		]
	},
	{
		state: "North Carolina",
		abbreviation: "NC",
		cities: [
			{
				name: "Charlotte",
				uri: "self-storage/north-carolina/charlotte/",
				latitude: 35.2272086,
				longitude: -80.8430827
			},
			{
				name: "Raleigh",
				uri: "self-storage/north-carolina/raleigh/",
				latitude: 35.7803977,
				longitude: -78.6390989
			},
			{
				name: "Fayetteville",
				uri: "self-storage/north-carolina/fayetteville/",
				latitude: 35.0525759,
				longitude: -78.878292
			},
			{
				name: "Wilmington",
				uri: "self-storage/north-carolina/wilmington/",
				latitude: 34.2352853,
				longitude: -77.9487284
			},
			{
				name: "Asheville",
				uri: "self-storage/north-carolina/asheville/",
				latitude: 35.595363,
				longitude: -82.5508407
			},
			{
				name: "Winston-Salem",
				uri: "self-storage/north-carolina/winston-salem/",
				latitude: 36.0998131,
				longitude: -80.2440518
			},
			{
				name: "Greensboro",
				uri: "self-storage/north-carolina/greensboro/",
				latitude: 36.0726355,
				longitude: -79.7919754
			},
			{
				name: "Durham",
				uri: "self-storage/north-carolina/durham/",
				latitude: 35.996653,
				longitude: -78.9018053
			},
			{
				name: "Concord",
				uri: "self-storage/north-carolina/concord/",
				latitude: 35.4087517,
				longitude: -80.579511
			},
			{
				name: "Jacksonville",
				uri: "self-storage/north-carolina/jacksonville/",
				latitude: 34.7509962,
				longitude: -77.4309829
			}
		]
	},
	{
		state: "North Dakota",
		abbreviation: "ND",
		cities: [
			{
				name: "Bismarck",
				uri: "self-storage/north-dakota/bismarck/",
				latitude: 46.808327,
				longitude: -100.783739
			},
			{
				name: "Fargo",
				uri: "self-storage/north-dakota/fargo/",
				latitude: 46.877229,
				longitude: -96.789821
			},
			{
				name: "Dickinson",
				uri: "self-storage/north-dakota/dickinson/",
				latitude: 46.8791756,
				longitude: -102.7896242
			},
			{
				name: "Grand Forks",
				uri: "self-storage/north-dakota/grand-forks/",
				latitude: 47.9252104,
				longitude: -97.0306325
			},
			{
				name: "Minot",
				uri: "self-storage/north-dakota/minot/",
				latitude: 48.23251,
				longitude: -101.296273
			},
			{
				name: "Williston",
				uri: "self-storage/north-dakota/williston/",
				latitude: 48.1465457,
				longitude: -103.621814
			},
			{
				name: "Watford City",
				uri: "self-storage/north-dakota/watford-city/",
				latitude: 47.802241,
				longitude: -103.283247
			},
			{
				name: "Valley City",
				uri: "self-storage/north-dakota/valley-city/",
				latitude: 46.923312,
				longitude: -98.003154
			},
			{
				name: "Devils Lake",
				uri: "self-storage/north-dakota/devils-lake/",
				latitude: 48.112779,
				longitude: -98.86512
			},
			{
				name: "Wahpeton",
				uri: "self-storage/north-dakota/wahpeton/",
				latitude: 46.265879,
				longitude: -96.608863
			}
		]
	},
	{
		state: "Ohio",
		abbreviation: "OH",
		cities: [
			{
				name: "Cleveland",
				uri: "self-storage/ohio/cleveland/",
				latitude: 41.4996574,
				longitude: -81.6936772
			},
			{
				name: "Cincinnati",
				uri: "self-storage/ohio/cincinnati/",
				latitude: 39.1014537,
				longitude: -84.5124602
			},
			{
				name: "Columbus",
				uri: "self-storage/ohio/columbus/",
				latitude: 39.9622601,
				longitude: -83.0007065
			},
			{
				name: "Toledo",
				uri: "self-storage/ohio/toledo/",
				latitude: 41.6529143,
				longitude: -83.5378173
			},
			{
				name: "Akron",
				uri: "self-storage/ohio/akron/",
				latitude: 41.083064,
				longitude: -81.518485
			},
			{
				name: "Hamilton",
				uri: "self-storage/ohio/hamilton/",
				latitude: 39.3995008,
				longitude: -84.5613355
			},
			{
				name: "Canton",
				uri: "self-storage/ohio/canton/",
				latitude: 40.7985464,
				longitude: -81.3749508
			},
			{
				name: "Dayton",
				uri: "self-storage/ohio/dayton/",
				latitude: 39.7589478,
				longitude: -84.1916069
			},
			{
				name: "Dublin",
				uri: "self-storage/ohio/dublin/",
				latitude: 40.0992294,
				longitude: -83.1140771
			},
			{
				name: "Elyria",
				uri: "self-storage/ohio/elyria/",
				latitude: 41.3683798,
				longitude: -82.1076486
			}
		]
	},
	{
		state: "Oklahoma",
		abbreviation: "OK",
		cities: [
			{
				name: "Norman",
				uri: "self-storage/oklahoma/norman/",
				latitude: 35.2225717,
				longitude: -97.4394816
			},
			{
				name: "Tulsa",
				uri: "self-storage/oklahoma/tulsa/",
				latitude: 36.1563122,
				longitude: -95.9927516
			},
			{
				name: "Edmond",
				uri: "self-storage/oklahoma/edmond/",
				latitude: 35.6571367,
				longitude: -97.4649038
			},
			{
				name: "Oklahoma City",
				uri: "self-storage/oklahoma/oklahoma-city/",
				latitude: 35.4729886,
				longitude: -97.5170536
			},
			{
				name: "Broken Arrow",
				uri: "self-storage/oklahoma/broken-arrow/",
				latitude: 36.0525993,
				longitude: -95.7908195
			},
			{
				name: "Lawton",
				uri: "self-storage/oklahoma/lawton/",
				latitude: 34.6051975,
				longitude: -98.3952279
			},
			{
				name: "Stillwater",
				uri: "self-storage/oklahoma/still-water/",
				latitude: 36.1156306,
				longitude: -97.0585717
			},
			{
				name: "Owasso",
				uri: "self-storage/oklahoma/owasso/",
				latitude: 36.269539,
				longitude: -95.854713
			},
			{
				name: "Shawnee",
				uri: "self-storage/oklahoma/shawnee/",
				latitude: 35.327292,
				longitude: -96.9253
			},
			{
				name: "Enid",
				uri: "self-storage/oklahoma/enid/",
				latitude: 36.3967623,
				longitude: -97.8791341
			}
		]
	},
	{
		state: "Oregon",
		abbreviation: "OR",
		cities: [
			{
				name: "Portland",
				uri: "self-storage/oregon/portland/",
				latitude: 45.5202471,
				longitude: -122.674194
			},
			{
				name: "Salem",
				uri: "self-storage/oregon/salem/",
				latitude: 44.9391565,
				longitude: -123.033121
			},
			{
				name: "Beaverton",
				uri: "self-storage/oregon/beaverton/",
				latitude: 45.4871723,
				longitude: -122.80378
			},
			{
				name: "Grants Pass",
				uri: "self-storage/oregon/grants-pass/",
				latitude: 42.4393707,
				longitude: -123.3272489
			},
			{
				name: "Hillsboro",
				uri: "self-storage/oregon/hillsboro/",
				latitude: 45.5228939,
				longitude: -122.989827
			},
			{
				name: "Oregon City",
				uri: "self-storage/oregon/oregon-city/",
				latitude: 45.357342,
				longitude: -122.606758
			},
			{
				name: "McMinnville",
				uri: "self-storage/oregon/mcminnville/",
				latitude: 45.210115,
				longitude: -123.198716
			},
			{
				name: "Bend",
				uri: "self-storage/oregon/bend/",
				latitude: 44.0581728,
				longitude: -121.3153096
			},
			{
				name: "Tigard",
				uri: "self-storage/oregon/tigard/",
				latitude: 45.4312294,
				longitude: -122.771486
			},
			{
				name: "Eugene",
				uri: "self-storage/oregon/eugene/",
				latitude: 44.0505054,
				longitude: -123.0950506
			}
		]
	},
	{
		state: "Pennsylvania",
		abbreviation: "PA",
		cities: [
			{
				name: "Lancaster",
				uri: "self-storage/pennsylvania/lancaster/",
				latitude: 40.0379958,
				longitude: -76.3056707
			},
			{
				name: "Pittsburgh",
				uri: "self-storage/pennsylvania/pittsburgh/",
				latitude: 40.4406968,
				longitude: -80.0025666
			},
			{
				name: "York",
				uri: "self-storage/pennsylvania/york/",
				latitude: 39.9625984,
				longitude: -76.727745
			},
			{
				name: "Erie",
				uri: "self-storage/pennsylvania/erie/",
				latitude: 42.1294712,
				longitude: -80.0852695
			},
			{
				name: "Harrisburg",
				uri: "self-storage/pennsylvania/harrisburg/",
				latitude: 40.2663107,
				longitude: -76.8861122
			},
			{
				name: "Philadelphia",
				uri: "self-storage/pennsylvania/philadelphia/",
				latitude: 39.9527237,
				longitude: -75.1635262
			},
			{
				name: "Allentown",
				uri: "self-storage/pennsylvania/allentown/",
				latitude: 40.6022552,
				longitude: -75.4716115
			},
			{
				name: "Bethlehem",
				uri: "self-storage/pennsylvania/bethlehem/",
				latitude: 40.6259316,
				longitude: -75.3704579
			},
			{
				name: "Reading",
				uri: "self-storage/pennsylvania/reading/",
				latitude: 40.335345,
				longitude: -75.9279495
			},
			{
				name: "Scranton",
				uri: "self-storage/pennsylvania/scranton/",
				latitude: 41.4086874,
				longitude: -75.6621294
			}
		]
	},
	{
		state: "Rhode Island",
		abbreviation: "RI",
		cities: [
			{
				name: "Providence",
				uri: "self-storage/rhode-island/providence/",
				latitude: 41.8239891,
				longitude: -71.4128343
			},
			{
				name: "Pawtucket",
				uri: "self-storage/rhode-island/pawtucket/",
				latitude: 41.8789531,
				longitude: -71.3821203
			},
			{
				name: "Warwick",
				uri: "self-storage/rhode-island/warwick/",
				latitude: 41.6992717,
				longitude: -71.4586114
			},
			{
				name: "Johnston",
				uri: "self-storage/rhode-island/johnston/",
				latitude: 41.82926,
				longitude: -71.51478
			},
			{
				name: "East Providence",
				uri: "self-storage/rhode-island/east-providence/",
				latitude: 41.8194081,
				longitude: -71.376257
			},
			{
				name: "Westerly",
				uri: "self-storage/rhode-island/westerly/",
				latitude: 41.3775996,
				longitude: -71.8272911
			},
			{
				name: "Woonsocket",
				uri: "self-storage/rhode-island/woonsocket/",
				latitude: 42.0028761,
				longitude: -71.5147839
			},
			{
				name: "Smithfield",
				uri: "self-storage/rhode-island/smithfield/",
				latitude: 41.92121,
				longitude: -71.5493
			},
			{
				name: "Cranston",
				uri: "self-storage/rhode-island/cranston/",
				latitude: 41.779588,
				longitude: -71.4366813
			},
			{
				name: "Coventry",
				uri: "self-storage/rhode-island/coventry/",
				latitude: 41.7001,
				longitude: -71.682
			}
		]
	},
	{
		state: "South Carolina",
		abbreviation: "SC",
		cities: [
			{
				name: "Greenville",
				uri: "self-storage/south-carolina/greenville/",
				latitude: 34.851354,
				longitude: -82.3984882
			},
			{
				name: "Columbia",
				uri: "self-storage/south-carolina/columbia/",
				latitude: 34.000754,
				longitude: -81.0352313
			},
			{
				name: "Aiken",
				uri: "self-storage/south-carolina/aiken/",
				latitude: 33.5604168,
				longitude: -81.7195533
			},
			{
				name: "Rock Hill",
				uri: "self-storage/south-carolina/rock-hill/",
				latitude: 34.9248667,
				longitude: -81.0250784
			},
			{
				name: "Summerville",
				uri: "self-storage/south-carolina/summerville/",
				latitude: 33.0186699,
				longitude: -80.1762704
			},
			{
				name: "Anderson",
				uri: "self-storage/south-carolina/anderson/",
				latitude: 34.5068601,
				longitude: -82.6506264
			},
			{
				name: "Charleston",
				uri: "self-storage/south-carolina/charleston/",
				latitude: 32.7884363,
				longitude: -79.9399309
			},
			{
				name: "Mount Pleasant",
				uri: "self-storage/south-carolina/mount-pleasant/",
				latitude: 32.8323225,
				longitude: -79.8284258
			},
			{
				name: "Myrtle Beach",
				uri: "self-storage/south-carolina/myrtle-beach/",
				latitude: 33.6956461,
				longitude: -78.8900409
			},
			{
				name: "Spartanburg",
				uri: "self-storage/south-carolina/spartanburg/",
				latitude: 34.9498007,
				longitude: -81.9320157
			}
		]
	},
	{
		state: "South Dakota",
		abbreviation: "SD",
		cities: [
			{
				name: "Rapid City",
				uri: "self-storage/south-dakota/rapid-city/",
				latitude: 44.0806041,
				longitude: -103.228023
			},
			{
				name: "Sioux Falls",
				uri: "self-storage/south-dakota/sioux-falls/",
				latitude: 43.5476008,
				longitude: -96.7293629
			},
			{
				name: "Brookings",
				uri: "self-storage/south-dakota/brookings/",
				latitude: 44.311461,
				longitude: -96.79844
			},
			{
				name: "Spearfish",
				uri: "self-storage/south-dakota/spearfish/",
				latitude: 44.4893896,
				longitude: -103.8609632
			},
			{
				name: "Aberdeen",
				uri: "self-storage/south-dakota/aberdeen/",
				latitude: 45.464698,
				longitude: -98.486483
			},
			{
				name: "Tea",
				uri: "self-storage/south-dakota/tea/",
				latitude: 43.447188,
				longitude: -96.835549
			},
			{
				name: "Watertown",
				uri: "self-storage/south-dakota/watertown/",
				latitude: 44.899211,
				longitude: -97.115289
			},
			{
				name: "Yankton",
				uri: "self-storage/south-dakota/yankton/",
				latitude: 42.871108,
				longitude: -97.397281
			},
			{
				name: "Vermillion",
				uri: "self-storage/south-dakota/vermillion/",
				latitude: 42.78083,
				longitude: -96.92966
			},
			{
				name: "Pierre",
				uri: "self-storage/south-dakota/pierre/",
				latitude: 44.368316,
				longitude: -100.350966
			}
		]
	},
	{
		state: "Tennessee",
		abbreviation: "TN",
		cities: [
			{
				name: "Memphis",
				uri: "self-storage/tennessee/memphis/",
				latitude: 35.1460249,
				longitude: -90.0517638
			},
			{
				name: "Knoxville",
				uri: "self-storage/tennessee/knoxville/",
				latitude: 35.9603948,
				longitude: -83.9210261
			},
			{
				name: "Clarksville",
				uri: "self-storage/tennessee/clarksville/",
				latitude: 36.5277607,
				longitude: -87.3588703
			},
			{
				name: "Murfreesboro",
				uri: "self-storage/tennessee/murfreesboro/",
				latitude: 35.8460396,
				longitude: -86.3921096
			},
			{
				name: "Chattanooga",
				uri: "self-storage/tennessee/chattanooga/",
				latitude: 35.0457219,
				longitude: -85.3094883
			},
			{
				name: "Nashville",
				uri: "self-storage/tennessee/nashville/",
				latitude: 36.1622767,
				longitude: -86.7742984
			},
			{
				name: "Cleveland",
				uri: "self-storage/tennessee/cleveland/",
				latitude: 35.1595182,
				longitude: -84.8766115
			},
			{
				name: "Franklin",
				uri: "self-storage/tennessee/franklin/",
				latitude: 35.925206,
				longitude: -86.8689419
			},
			{
				name: "Johnson City",
				uri: "self-storage/tennessee/johnson-city/",
				latitude: 36.3167671,
				longitude: -82.352903
			},
			{
				name: "Lebanon",
				uri: "self-storage/tennessee/lebanon/",
				latitude: 36.20811,
				longitude: -86.2911
			}
		]
	},
	{
		state: "Texas",
		abbreviation: "TX",
		cities: [
			{
				name: "Houston",
				uri: "self-storage/texas/houston/",
				latitude: 29.7589382,
				longitude: -95.3676974
			},
			{
				name: "Austin",
				uri: "self-storage/texas/austin/",
				latitude: 30.2711286,
				longitude: -97.7436995
			},
			{
				name: "McKinney",
				uri: "self-storage/texas/mckinney/",
				latitude: 33.197246,
				longitude: -96.639782
			},
			{
				name: "Amarillo",
				uri: "self-storage/texas/amarillo/",
				latitude: 35.207218,
				longitude: -101.833824
			},
			{
				name: "Corpus Christi",
				uri: "self-storage/texas/corpus-christi/",
				latitude: 27.800583,
				longitude: -97.396381
			},
			{
				name: "Laredo",
				uri: "self-storage/texas/laredo/",
				latitude: 27.530567,
				longitude: -99.480324
			},
			{
				name: "El Paso",
				uri: "self-storage/texas/el-paso/",
				latitude: 31.7601001,
				longitude: -106.4870476
			},
			{
				name: "Lubbock",
				uri: "self-storage/texas/lubbock/",
				latitude: 33.5855677,
				longitude: -101.8470215
			},
			{
				name: "Fort Worth",
				uri: "self-storage/texas/fort-worth/",
				latitude: 32.753177,
				longitude: -97.3327459
			},
			{
				name: "Denton",
				uri: "self-storage/texas/denton/",
				latitude: 33.214841,
				longitude: -97.133068
			}
		]
	},
	{
		state: "Utah",
		abbreviation: "UT",
		cities: [
			{
				name: "Salt Lake City",
				uri: "self-storage/utah/salt-lake-city/",
				latitude: 40.7596198,
				longitude: -111.886797
			},
			{
				name: "St George",
				uri: "self-storage/utah/st-george/",
				latitude: 37.1098772,
				longitude: -113.5832063
			},
			{
				name: "West Jordan",
				uri: "self-storage/utah/west-jordan/",
				latitude: 40.6061337,
				longitude: -111.9395211
			},
			{
				name: "Layton",
				uri: "self-storage/utah/layton/",
				latitude: 41.0751048,
				longitude: -111.9741925
			},
			{
				name: "Murray",
				uri: "self-storage/utah/murray/",
				latitude: 40.6667841,
				longitude: -111.888417
			},
			{
				name: "South Jordan",
				uri: "self-storage/utah/south-jordan/",
				latitude: 40.56217,
				longitude: -111.929658
			},
			{
				name: "Spanish Fork",
				uri: "self-storage/utah/spanish-fork/",
				latitude: 40.114955,
				longitude: -111.654923
			},
			{
				name: "Ogden",
				uri: "self-storage/utah/ogden/",
				latitude: 41.2230048,
				longitude: -111.9738429
			},
			{
				name: "Orem",
				uri: "self-storage/utah/orem/",
				latitude: 40.2981599,
				longitude: -111.6944313
			},
			{
				name: "Sandy",
				uri: "self-storage/utah/sandy/",
				latitude: 40.564979,
				longitude: -111.838972
			}
		]
	},
	{
		state: "Vermont",
		abbreviation: "VT",
		cities: [
			{
				name: "Burlington",
				uri: "self-storage/vermont/burlington/",
				latitude: 44.4761601,
				longitude: -73.212906
			},
			{
				name: "Rutland",
				uri: "self-storage/vermont/rutland/",
				latitude: 43.6084792,
				longitude: -72.9724768
			},
			{
				name: "Middlebury",
				uri: "self-storage/vermont/middlebury/",
				latitude: 44.015337,
				longitude: -73.16734
			},
			{
				name: "Bennington",
				uri: "self-storage/vermont/bennington/",
				latitude: 42.8788667,
				longitude: -73.1968205
			},
			{
				name: "Williston",
				uri: "self-storage/vermont/williston/",
				latitude: 44.4376099,
				longitude: -73.0682659
			},
			{
				name: "Barre",
				uri: "self-storage/vermont/barre/",
				latitude: 44.197005,
				longitude: -72.502037
			},
			{
				name: "Brattleboro",
				uri: "self-storage/vermont/brattleboro/",
				latitude: 42.8507588,
				longitude: -72.5572913
			},
			{
				name: "St Johnsbury",
				uri: "self-storage/vermont/st-johnsbury/",
				latitude: 44.41913,
				longitude: -72.01538
			},
			{
				name: "Colchester",
				uri: "self-storage/vermont/colchester/",
				latitude: 44.543814,
				longitude: -73.149594
			},
			{
				name: "Montpelier",
				uri: "self-storage/vermont/montpelier/",
				latitude: 44.260059,
				longitude: -72.575386
			}
		]
	},
	{
		state: "Virginia",
		abbreviation: "VA",
		cities: [
			{
				name: "Richmond",
				uri: "self-storage/virginia/richmond/",
				latitude: 37.5385087,
				longitude: -77.43428
			},
			{
				name: "Alexandria",
				uri: "self-storage/virginia/alexandria/",
				latitude: 38.8051095,
				longitude: -77.0470229
			},
			{
				name: "Arlington",
				uri: "self-storage/virginia/arlington/",
				latitude: 38.8903961,
				longitude: -77.0841585
			},
			{
				name: "Chesapeake",
				uri: "self-storage/virginia/chesapeake/",
				latitude: 36.768208,
				longitude: -76.287493
			},
			{
				name: "Norfolk",
				uri: "self-storage/virginia/norfolk/",
				latitude: 36.8493695,
				longitude: -76.2899539
			},
			{
				name: "Harrisonburg",
				uri: "self-storage/virginia/harrisonburg/",
				latitude: 38.449568,
				longitude: -78.868916
			},
			{
				name: "Lynchburg",
				uri: "self-storage/virginia/lynchburg/",
				latitude: 37.4137536,
				longitude: -79.1422464
			},
			{
				name: "Roanoke",
				uri: "self-storage/virginia/roanoke/",
				latitude: 37.270973,
				longitude: -79.9414313
			},
			{
				name: "Virginia Beach",
				uri: "self-storage/virginia/virginia-beach/",
				latitude: 36.8496579,
				longitude: -75.9760751
			},
			{
				name: "Hampton",
				uri: "self-storage/virginia/hampton/",
				latitude: 37.029868,
				longitude: -76.345222
			}
		]
	},
	{
		state: "Washington",
		abbreviation: "WA",
		cities: [
			{
				name: "Vancouver",
				uri: "self-storage/washington/vancouver/",
				latitude: 45.6306954,
				longitude: -122.6744557
			},
			{
				name: "Bellingham",
				uri: "self-storage/washington/bellingham/",
				latitude: 48.7544012,
				longitude: -122.478836
			},
			{
				name: "Federal Way",
				uri: "self-storage/washington/federal-way/",
				latitude: 47.322322,
				longitude: -122.312622
			},
			{
				name: "Spokane",
				uri: "self-storage/washington/spokane/",
				latitude: 47.6571934,
				longitude: -117.42351
			},
			{
				name: "Auburn",
				uri: "self-storage/washington/auburn/",
				latitude: 47.307322,
				longitude: -122.228453
			},
			{
				name: "Tacoma",
				uri: "self-storage/washington/tacoma/",
				latitude: 47.2455013,
				longitude: -122.438329
			},
			{
				name: "Everett",
				uri: "self-storage/washington/everett/",
				latitude: 47.9793437,
				longitude: -122.2127011
			},
			{
				name: "Marysville",
				uri: "self-storage/washington/marysville/",
				latitude: 48.051763,
				longitude: -122.177082
			},
			{
				name: "Seattle",
				uri: "self-storage/washington/seattle/",
				latitude: 47.6038321,
				longitude: -122.330062
			},
			{
				name: "Bellevue",
				uri: "self-storage/washington/bellevue/",
				latitude: 47.6144219,
				longitude: -122.192337
			}
		]
	},
	{
		state: "West Virginia",
		abbreviation: "WV",
		cities: [
			{
				name: "Morgantown",
				uri: "self-storage/west-virginia/morgantown/",
				latitude: 39.6296809,
				longitude: -79.9559437
			},
			{
				name: "Martinsburg",
				uri: "self-storage/west-virginia/martinsburg/",
				latitude: 39.4562528,
				longitude: -77.9639604
			},
			{
				name: "Charleston",
				uri: "self-storage/west-virginia/charleston/",
				latitude: 38.3505995,
				longitude: -81.6332812
			},
			{
				name: "Huntington",
				uri: "self-storage/west-virginia/huntington/",
				latitude: 38.4192496,
				longitude: -82.445154
			},
			{
				name: "Parkersburg",
				uri: "self-storage/west-virginia/parkersburg/",
				latitude: 39.2667309,
				longitude: -81.5620755
			},
			{
				name: "Charles Town",
				uri: "self-storage/west-virginia/charles-town/",
				latitude: 39.2891836,
				longitude: -77.859581
			},
			{
				name: "Fairmont",
				uri: "self-storage/west-virginia/fairmont/",
				latitude: 39.484898,
				longitude: -80.1426539
			},
			{
				name: "Beckley",
				uri: "self-storage/west-virginia/beckley/",
				latitude: 37.7781702,
				longitude: -81.1881557
			},
			{
				name: "Wheeling",
				uri: "self-storage/west-virginia/wheeling/",
				latitude: 40.0639616,
				longitude: -80.7209149
			},
			{
				name: "Clarksburg",
				uri: "self-storage/west-virginia/clarksburg/",
				latitude: 39.280645,
				longitude: -80.344534
			}
		]
	},
	{
		state: "Wisconsin",
		abbreviation: "WI",
		cities: [
			{
				name: "Madison",
				uri: "self-storage/wisconsin/madison/",
				latitude: 43.07469,
				longitude: -89.3841663
			},
			{
				name: "Milwaukee",
				uri: "self-storage/wisconsin/milwaukee/",
				latitude: 43.0386475,
				longitude: -87.9090751
			},
			{
				name: "Appleton",
				uri: "self-storage/wisconsin/appleton/",
				latitude: 44.2613967,
				longitude: -88.4069744
			},
			{
				name: "Eau Claire",
				uri: "self-storage/wisconsin/eau-claire/",
				latitude: 44.811349,
				longitude: -91.4984941
			},
			{
				name: "Green Bay",
				uri: "self-storage/wisconsin/green-bay/",
				latitude: 44.5126379,
				longitude: -88.0125794
			},
			{
				name: "Kenosha",
				uri: "self-storage/wisconsin/kenosha/",
				latitude: 42.584743,
				longitude: -87.821185
			},
			{
				name: "La Crosse",
				uri: "self-storage/wisconsin/la-crosse/",
				latitude: 43.8122836,
				longitude: -91.2514355
			},
			{
				name: "Janesville",
				uri: "self-storage/wisconsin/janesville/",
				latitude: 42.6829765,
				longitude: -89.0226793
			},
			{
				name: "Racine",
				uri: "self-storage/wisconsin/racine/",
				latitude: 42.72613,
				longitude: -87.782852
			},
			{
				name: "Sheboygan",
				uri: "self-storage/wisconsin/sheboygan/",
				latitude: 43.750828,
				longitude: -87.71453
			}
		]
	},
	{
		state: "Wyoming",
		abbreviation: "WY",
		cities: [
			{
				name: "Cheyenne",
				uri: "self-storage/wyoming/cheyenne/",
				latitude: 41.139981,
				longitude: -104.820246
			},
			{
				name: "Casper",
				uri: "self-storage/wyoming/casper/",
				latitude: 42.8501191,
				longitude: -106.325138
			},
			{
				name: "Gillette",
				uri: "self-storage/wyoming/gilette/",
				latitude: 44.291091,
				longitude: -105.502796
			},
			{
				name: "Sheridan",
				uri: "self-storage/wyoming/sheridan/",
				latitude: 44.797194,
				longitude: -106.956179
			},
			{
				name: "Laramie",
				uri: "self-storage/wyoming/laramie/",
				latitude: 41.3116442,
				longitude: -105.5917876
			},
			{
				name: "Rock Springs",
				uri: "self-storage/wyoming/rock-springs/",
				latitude: 41.5860557,
				longitude: -109.2194544
			},
			{
				name: "Cody",
				uri: "self-storage/wyoming/cody/",
				latitude: 44.5263107,
				longitude: -109.056392
			},
			{
				name: "Evanston",
				uri: "self-storage/wyoming/evanston/",
				latitude: 41.268279,
				longitude: -110.963237
			},
			{
				name: "Jackson",
				uri: "self-storage/wyoming/jackson/",
				latitude: 43.479965,
				longitude: -110.761815
			},
			{
				name: "Lander",
				uri: "self-storage/wyoming/lander/",
				latitude: 42.833014,
				longitude: -108.730673
			}
		]
	}
];

export const storageNearYouStates = {
	title: "Storage facilities across the country",
	cities: [
		{
			uri: "self-storage/georgia/atlanta/",
			name: "Atlanta, GA",
			latitude: 33.749,
			longitude: -84.388
		},
		{
			uri: "self-storage/massachusetts/boston/",
			name: "Boston, MA",
			latitude: 42.3601,
			longitude: -71.0589
		},
		{
			uri: "self-storage/michigan/detroit/",
			name: "Detroit, MI",
			latitude: 42.3314,
			longitude: -83.0458
		},
		{
			uri: "self-storage/california/los-angeles/",
			name: "Los Angeles, CA",
			latitude: 34.0536909,
			longitude: -118.242766
		},
		{
			uri: "self-storage/minnesota/minneapolis/",
			name: "Minneapolis, MN",
			latitude: 44.9778,
			longitude: -93.265
		},
		{
			uri: "self-storage/new-york/new-york/",
			name: "New York, NY",
			latitude: 40.7127281,
			longitude: -74.0060152
		},
		{
			uri: "self-storage/oregon/portland/",
			name: "Portland, OR",
			latitude: 45.5152,
			longitude: -122.6784
		},
		{
			uri: "self-storage/texas/san-antonio/",
			name: "San Antonio, TX",
			latitude: 29.4241,
			longitude: -98.4936
		}
	]
};
